module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/rustic-341f76351088a96c8166139f10a1d7c2.jpg";